import { Link } from "react-router-dom";
import { Mail, Globe, ArrowUpRight } from "lucide-react";
import { COMPANY, SERVICES, INDUSTRIES } from "@/lib/siteData";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0b192c] text-slate-200 relative overflow-hidden"
    >
      <div className="absolute inset-0 vd-grid-bg-dark opacity-60 pointer-events-none" />
      <div className="vd-container relative py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="inline-block">
              <img
                src="https://customer-assets.emergentagent.com/job_c-suite-hub-1/artifacts/ara3n48d_image.png"
                alt="VeriData Global — Trusted, Timely, Thorough"
                className="h-36 md:h-44 w-auto object-contain rounded-md"
              />
            </div>
            <p className="mt-5 text-slate-400 leading-relaxed max-w-sm text-[15px]">
              Your trusted partner for survey programming, data collection, data
              processing, reporting, and global fieldwork. Supporting market
              research agencies, consulting firms, and enterprise insights teams
              worldwide.
            </p>

            <div className="mt-8 space-y-3 text-sm">
              <a
                href={`mailto:${COMPANY.email}`}
                data-testid="footer-email-link"
                className="inline-flex items-center gap-2 text-slate-300 hover:text-teal-400 transition-colors"
              >
                <Mail className="h-4 w-4" /> {COMPANY.email}
              </a>
              <div className="flex items-center gap-2 text-slate-400">
                <Globe className="h-4 w-4" /> {COMPANY.website}
              </div>
            </div>
          </div>

          <div className="lg:col-span-3">
            <p className="text-xs font-semibold tracking-[0.2em] uppercase text-teal-400 mb-5">
              Services
            </p>
            <ul className="space-y-3 text-[15px]">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/services/${s.slug}`}
                    data-testid={`footer-service-${s.slug}`}
                    className="text-slate-300 hover:text-white transition-colors"
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="text-xs font-semibold tracking-[0.2em] uppercase text-teal-400 mb-5">
              Industries
            </p>
            <ul className="space-y-3 text-[15px]">
              {INDUSTRIES.map((i) => (
                <li key={i.name} className="text-slate-300">
                  {i.name}
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="text-xs font-semibold tracking-[0.2em] uppercase text-teal-400 mb-5">
              Engage
            </p>
            <Link
              to="/contact"
              data-testid="footer-cta-link"
              className="inline-flex items-center gap-2 text-white font-medium border-b border-orange-500 pb-1 hover:border-white transition-colors"
            >
              Start a project <ArrowUpRight className="h-4 w-4" />
            </Link>
            <p className="mt-6 text-xs text-slate-500 leading-relaxed">
              Single partner. Full research lifecycle. Global execution.
            </p>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-slate-500">
          <p>
            © {new Date().getFullYear()} VeriData Global. All rights reserved.
          </p>
          <p className="tracking-[0.2em] uppercase">
            Trusted · Timely · Thorough
          </p>
        </div>
      </div>
    </footer>
  );
}
